import { createSlice } from '@reduxjs/toolkit';

const initialStateProto = {
  username: {
    error: false,
    helpertext: ' ',
    value: '',
  },
  password: {
    error: false,
    helpertext: ' ',
    value: '',
  },
  phoneNumber: {
    error: false,
    helpertext: ' ',
    value: '',
  },
  phoneNumberOtp: {
    error: false,
    helpertext: ' ',
    value: '',
  },
  isMobile: false,
};

export const loginFormSlice = createSlice({
  name: 'loginForm',
  initialState: {
    ...initialStateProto,
  },
  reducers: {
    update: (state, action) => {
      const load = action.payload;
      const name = Object.keys(load)[0];

      // console.log(name, load['username']['value'].length, 'in slice');

      // if (name === 'username' && load['username']['value'].length === 10) {
      //   const stringValue = load['username']['value'];
      //   const numberValue = Number(stringValue);
      //   const stringValueTwo = numberValue.toString();
      //   const checkStringLength = stringValueTwo.length;

      //   if (checkStringLength === 10) {
      //     return { ...state, phoneNumber: load[name], isMobile: true };
      //   } else {
      //     return { ...state, [name]: load[name], isMobile: false };
      //   }
      // }

      return { ...state, [name]: load[name] };
    },
    clearForm: () => {
      return { ...initialStateProto };
    },
  },
});

export const { update, clearForm } = loginFormSlice.actions;

export default loginFormSlice.reducer;
